// English baseline translations.
// Source of truth for other locales. Keep keys stable — other language
// files mirror this shape. Traditional Chinese mirrors every key; the
// remaining 6 locales only translate navigation + CTA for now and will
// be extended when the full content pass happens.

const common = {
  // Navigation
  "nav.home": "Home",
  "nav.products": "Products",
  "nav.factory": "Factory",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.requestQuote": "Request Quote",
  "nav.menu": "Menu",
  "nav.language": "Language",

  // CTAs
  "cta.requestQuote": "Request a Quote",
  "cta.exploreCatalog": "Explore Catalog",
  "cta.contactUs": "Contact Us",
  "cta.scheduleFactoryVisit": "Schedule a Factory Visit",
  "cta.requestSample": "Request a Sample",
  "cta.viewAll": "View All Products",

  // Common terms
  "common.tbd": "[To be confirmed by Forwaro]",
  "common.category": "Category",
  "common.material": "Material",
  "common.style": "Style",
  "common.filters": "Filters",
  "common.resetAll": "Reset All",
  "common.details": "Details",

  // Brand
  "brand.name": "Forwaro Furniture",
  "brand.chineseName": "風華國際",
  "brand.tagline": "FORWARO FURNITURE · 風華國際 · 現代傢俱",

  // WhatsApp
  "whatsapp.cta": "Message us on WhatsApp",
  "wechat.cta": "Add us on WeChat",

  // Home · Hero
  "home.hero.badge": "FORWARO · 風華國際 · 現代傢俱",
  "home.hero.headline.line1": "Home is the",
  "home.hero.headline.line2Highlight": "center of all",
  "home.hero.headline.line3": "in a busy life.",
  "home.hero.subheadline":
    "Forwaro Furniture (風華國際) is a Dongguan-based OEM / ODM manufacturer pairing furniture design with consistent production quality for importers across the Middle East, Europe, the Americas and Asia.",
  "home.hero.stat1.value": "6",
  "home.hero.stat1.label": "Product lines",
  "home.hero.stat2.value": "OEM / ODM",
  "home.hero.stat2.label": "Tailored production",
  "home.hero.stat3.value": "Dongguan",
  "home.hero.stat3.label": "Min Tian Industrial Zone",
  "home.hero.stat4.value": "Global",
  "home.hero.stat4.label": "Export-ready partnerships",
  "home.hero.scroll": "Scroll",

  // Home · Categories
  "home.categories.kicker": "Our Product Range",
  "home.categories.heading": "Six product lines, one trusted factory",
  "home.categories.description":
    "Dining tables, coffee tables, console tables, chairs, sofas and TV cabinets: the six B2B furniture lines Forwaro produces for export.",

  // Home · About
  "home.about.kicker": "About Forwaro",
  "home.about.heading.line1": "Furniture design,",
  "home.about.heading.line2": "consistently crafted.",
  "home.about.philosophy.en":
    "Home is the centre of all in such a busy life, where the aesthetics of living becomes the taste and pursuit for successful people everywhere. Forwaro Furniture upholds the concept of furniture design and the consistency of quality — bringing your home a place where aesthetics and craftsmanship complement each other.",
  "home.about.location":
    "Forwaro Furniture (風華國際有限公司) was established in Taiwan in 1991 and has manufactured in mainland China since 2006, operating today from the Min Tian Industrial Zone, Shatian Town, Dongguan. Forwaro partners with importers who value honest craftsmanship and dependable delivery.",
  "home.about.highlight1.title": "OEM & ODM",
  "home.about.highlight1.body":
    "Tailored production — from private-label runs to fully customised design & engineering.",
  "home.about.highlight2.title": "Export-grade QC",
  "home.about.highlight2.body":
    "Inspection at every stage of joinery, finishing, and packing, prepared for long-haul freight.",
  "home.about.highlight3.title": "Natural marble & steel",
  "home.about.highlight3.body":
    "Signature tops in natural marble, paired with electroplated stainless-steel and iron bases.",
  "home.about.highlight4.title": "Global export reach",
  "home.about.highlight4.body":
    "Serving importers across the Middle East, Europe, the Americas and Asia from Dongguan.",
  "home.about.badgeLocation": "Dongguan, China",
  "home.about.badgeZone": "Min Tian Industrial Zone",
  "home.about.badgeOem": "OEM /\nODM",
  "home.about.badgeOemSub": "Custom & private-label",

  // Home · Featured Products
  "home.featured.kicker": "Catalogue Preview",
  "home.featured.heading": "A preview across Forwaro's six lines",
  "home.featured.description":
    "Genuine Forwaro model codes with confirmed materials and dimensions. Contact us for full specifications and a quotation.",

  // Home · Markets
  "home.markets.kicker": "Global Reach",
  "home.markets.heading": "Export markets we serve",
  "home.markets.description":
    "Forwaro partners with furniture importers, distributors, hospitality groups and residential projects across four continents.",

  // Home · Process
  "home.process.heading": "How we work with you",
  "home.process.description":
    "From first inquiry to container loading — Forwaro's standard export workflow",

  // Footer
  "footer.getInTouch.kicker": "Get In Touch",
  "footer.getInTouch.heading": "Start your furniture\nimport journey with Forwaro",
  "footer.getInTouch.description":
    "Our export team is ready to provide custom quotes, product samples, and full documentation support for your market.",
  "footer.contact.email": "Email",
  "footer.contact.phone": "Telephone",
  "footer.contact.fax": "Fax",
  "footer.contact.factory": "Factory",
  "footer.contact.whatsappNote": "WhatsApp & WeChat channels — to be confirmed by Forwaro.",
  "footer.form.heading": "Request a Quote",
  "footer.form.name": "Full Name",
  "footer.form.email": "Email",
  "footer.form.company": "Company",
  "footer.form.country": "Country",
  "footer.form.countryPlaceholder": "Select country",
  "footer.form.message": "Message",
  "footer.form.messagePlaceholder": "Tell us about your requirements, quantities, and target market...",
  "footer.form.submit": "Send Inquiry",
  "footer.form.sending": "Sending...",
  "footer.form.success.heading": "Message Sent!",
  "footer.form.success.body": "Our export team will respond within two business days.",
  "footer.form.sendAnother": "Send another message",
  "footer.footerTagline":
    "Forwaro Furniture · 風華國際 · 現代傢俱. OEM/ODM manufacturer based in Dongguan, serving importers across the Middle East, Europe, the Americas and Asia.",
  "footer.col.products": "Products",
  "footer.col.company": "Company",
  "footer.col.markets": "Export Markets",
  "footer.col.regional":
    "Looking for a regional representative?",
  "footer.copyright": "All rights reserved.",
};

export default common;
